import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './state/Auth';
import { DataProvider } from './state/Data';
import { SettingsProvider } from './state/Settings';
import { PortfolioMetaProvider } from './state/PortfolioMeta';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <BrowserRouter key='router'>
      <DataProvider>
        <AuthProvider>
          <PortfolioMetaProvider>
            <SettingsProvider>
              <App />
            </SettingsProvider>
          </PortfolioMetaProvider>
        </AuthProvider>
      </DataProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
